<template>
  <app-card
    class="p-6 flex flex-col"
    :status="project.collaboration_agreement_uploaded ? 'complete' : 'incomplete'"
  >
    <div>
      <app-badge
        v-if="project.collaboration_agreement_uploaded"
        type="positive"
        icon="check"
      >
        Uploaded
      </app-badge>
      <app-badge
        v-else
        type="neutral"
        icon="important"
      >
        Required
      </app-badge>
      <h2 class="text-lg mb-1">
        {{ project.ref }} Collaboration Agreement
      </h2>
    </div>
    <div
      class="text-grey-700 text-sm mb-6"
    >
      <p 
        v-if="!project.collaboration_agreement_uploaded"
        class="text-neutral-800 mb-2"
      >
        <b>Please upload your collaboration agreement</b>
      </p>
      <p><b>Collaborators:</b></p>
      <p
        v-for="partner in partners"
        :key="partner.id"
      >
        {{ partner.user.company.name }}
      </p>
    </div>
    <div class="border-t pt-4 mt-auto flex items-center">
      <icon-link
        v-if="project.collaboration_agreement_uploaded"
        :href="route('applications.files.download', { application: project.uuid, file: project.collaboration_agreement.id }) + '?project=1'"
        class="ml-auto"
        icon="cheveron-down-circle"
        icon-placement="right"
        target="_blank"
      >
        Download
      </icon-link>
    </div>
  </app-card>
</template>

<script>
export default {
  name:'FundingProjectCollaborationAgreementCard',
  props: {
    project: {
      type: Object,
      required: true
    },
    partners: {
      type: Array,
      required: true
    }
  }
}
</script>